import { type } from "arktype";
import { c as PW_MIN_LENGTH, e as BONUS_TYPES } from "./index3.js";
const userSignInSchema = type({
  email: type("string.lower").pipe(type("string.email")),
  password: `string > ${PW_MIN_LENGTH}`,
  "+": "delete"
  // Delete undeclared properties. @see https://arktype.io/docs/objects#properties-undeclared
});
const userSignUpSchema = userSignInSchema.merge({
  name: "string > 0",
  "image?": "string",
  repeatPassword: `string > ${PW_MIN_LENGTH}`
});
const userCardSchema = type({
  nickname: "string > 0",
  openedAt: type("string.date.parse").to(`Date < ${Date.now()}`),
  bonusAmount: type("string.integer.parse").to("0 < number.integer < 1000000"),
  bonusType: type("===", ...BONUS_TYPES),
  bonusSpend: type("string.integer.parse").to("0 < number < 1000000"),
  bonusDeadline: type("string.date.parse").to(`Date > ${Date.now()}`),
  annualFee: type("string.integer.parse").to("0 <= number < 1000"),
  "+": "delete"
  // Delete undeclared properties. @see https://arktype.io/docs/objects#properties-undeclared
});
export {
  userSignInSchema as a,
  userSignUpSchema as b,
  userCardSchema as u
};
